import axios from "axios";
import { BASE_URL, SUB_URL_wash } from "../BaseUrl";

const GetBinService = {

    ViewBinbyId: async (bin_id) => {
        console.log(bin_id);
        
        try {
            const formData = new FormData();
            formData.append("bin_id", bin_id);

            const response = await axios.post(
                `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_wash.view_bin}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            console.log("Response Data:", response.data);
            return response.data;
        } catch (error) {
            console.error(error);
        }
    },
};
export default GetBinService;